import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";  // Asegúrate de importar correctamente la instancia de Firestore
import "../Styles/Lobby.css";
import AccionesPlanificadas from "../Componentes/AccionesPlanificadas";
import bannerLogo from "../Assets/Banner.png";
import { FaPowerOff, FaCog} from "react-icons/fa";
import { useParams } from "react-router-dom";
import ImageViewer from "../Componentes/DashboardManager/ImageViewer";
import  {UseHubName}  from '../Hooks/UseHubName'; 
import GetUserData from "../Hooks/GetUserData";
import { useUserPermissions } from "../Hooks/GetUserPermissions";

const secciones = [
  { id: "grafo", nombre: "Mapa Societario", ruta: "/grafo" },
  { id: "documentacion", nombre: "Archivo documental", ruta: "/documentacion" },
  { id: "comunicaciones", nombre: "Comunicaciones", ruta: "/comunicaciones" },
  { id: "lobbyGestion", nombre: "Gestión", ruta: "/lobbyGestion" },
];

const Lobby = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const { hubId } = useParams();
  const hubName = UseHubName(hubId);
  const {userData} = GetUserData();
  const {permisos} = useUserPermissions();

  const [hasCalendar, setHasCalendar] = useState(true);
  const [hasMap, setHasMap] = useState(true);
  const [hasDocs, setHasDocs] = useState(true);
  const [hasPlans, setHasPlans] = useState(true);
  const [hasComms, setHasComms] = useState(true);


  useEffect(() => {
    const fetchHubConfig = async () => {
      if (!hubId) return;
      try {
        const hubDocRef = doc(db, "private-hubs", hubId);
        const hubDocSnap = await getDoc(hubDocRef);
        if (hubDocSnap.exists()) {
          const data = hubDocSnap.data();
          setHasCalendar(data.hasCalendar ?? false);
          setHasMap(data.hasMap ?? false);
          setHasDocs(data.hasDocs ?? false);
          setHasPlans(data.hasPlans ?? false);
          setHasComms(data.hasComms ?? false);
        } else {
          setHasCalendar(false); // Por defecto true si no existe
          setHasMap(false);
          setHasDocs(false);
          setHasPlans(false);
          setHasComms(false);
        }
      } catch (error) {
        console.error("Error cargando configuración de hub:", error);
        setHasCalendar(false); // fallback a true
        setHasMap(false);
        setHasDocs(false);
        setHasPlans(false);
        setHasComms(false);
      } 
    };

    fetchHubConfig();
  }, [hubId]);

  const handleLogout = () => {
    signOut(auth)
      .then(() => navigate("/"))
      .catch((error) => console.error("Logout error:", error));
  };

  // Filtrar secciones para no mostrar calendario si no está permitido
  const seccionesFiltradas = secciones.filter(sec => {
    if (sec.id === "lobbyGestion" && !hasCalendar) return false;
    if (sec.id === "grafo" && !hasMap) return false;
    if (sec.id === "documentacion" && !hasDocs) return false;
    if (sec.id === "soporte" && !hasPlans) return false;
    if (sec.id === "comunicaciones" && !hasComms) return false;
    return true;
  });

  return (
    <div className="lobby-container">
      {/* Header */}
      <div className="header-container">
        <header className="header">
          <h1 className="header-title-lobby">{hubName}</h1>
          <div className='logout-button-container'>
            {userData?.hubId?.includes("__superadmin__") && (
              <button
                className="logout-button config-button"
                onClick={() => navigate(`/lobby/${hubId}/config`)}
              >
                <FaCog className="logout-icon" />
              </button>
            )}

            <button className="logout-button" onClick={handleLogout}>
              <FaPowerOff className="logout-icon"  />
            </button>
          </div>
        </header>
      </div>
      
      {permisos && permisos.verDashboard && permisos.verDashboard !== "sin_acceso" && (
        <div className="image-box">
          <ImageViewer />
        </div>
      )}

      {/* Secciones Grid en fila (de 4 botones) */}
      <div className="secciones-row">
        {seccionesFiltradas.map((sec) => (
          <button
            key={sec.id}
            className="seccion-btn"
            onClick={() => navigate(`${sec.ruta}/${hubId}`)}
          >
            {sec.nombre}
          </button>
        ))}
      </div>

      {permisos && permisos.verAccPlan && permisos.verAccPlan !== "sin_acceso" && (
        <div className="data-box calendar-box">
          <AccionesPlanificadas />
        </div>
      )}

      <footer className="footer">
          <img 
              src={bannerLogo} 
              alt="Banner Logo" 
              style={{ display: "block", margin: "0 auto", width: "1000px", height: "auto" }} 
          />

      </footer>



    </div>
  );
};

export default Lobby;
